export default [
    {
        path: '/courses/add',
        name: 'courses-add',
        component: () => import(
            /* webpackChunkName: "courses-add" */ './../views/Courses/Add.vue'
        ),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/courses/edit/:id',
        name: 'courses-edit',
        component: () => import(
            /* webpackChunkName: "courses-edit" */ './../views/Courses/Edit.vue'
        ),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/courses',
        name: 'courses',
        component: () => import(
            /* webpackChunkName: "courses" */ './../views/Courses/List.vue'
        ),
        meta: {
            requiresAuth: true
        }
    }
];